module.exports = __webpack_public_path__ + "static/dmon-021-3041e1f420eb2fa0d3207e0e85862d86.jpg";